<template>
  <div class="api-drawer-footer">
    <BittsButton
      :text="removeText"
      type="danger"
      variant="ghost"
      :left-icon="['fak', 'delete']"
      :disabled="isRemoveDisabled"
      @click="emit('remove')"
    />
    <BittsButton
      text="Save settings"
      :loading="isSaving"
      :disabled="isSaveDisabled"
      @click="emit('save')"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';

const {
  removeText,
  isSaving = false,
  isSaveDisabled = false,
  isRemoveDisabled = false,
} = defineProps<{
  removeText: string;
  isSaving?: boolean;
  isSaveDisabled?: boolean;
  isRemoveDisabled?: boolean;
}>();

const emit = defineEmits<{
  save: [];
  remove: [];
}>();
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-drawer-footer {
  @apply flex items-center justify-between w-full;
}
</style>
